import { render, staticRenderFns } from "./login-pass.vue?vue&type=template&id=81e26eb0&scoped=true&"
import script from "./login-pass.vue?vue&type=script&lang=js&"
export * from "./login-pass.vue?vue&type=script&lang=js&"
import style0 from "./login-pass.vue?vue&type=style&index=0&id=81e26eb0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81e26eb0",
  null
  
)

export default component.exports